var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWozLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 29,
    viewBox: "0 0 125 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_888_3986)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_888_3986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 0,
    width: 18,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8767 0H33.8542V14.6716H50.8767V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_888_3986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1588 14.6577H46.6328L50.8768 7.32187L46.6328 0H38.1588L33.9148 7.32187L38.1588 14.6577Z",
    fill: "#86C7ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_888_3986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 27,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4119 0H16.9573V29H42.4119V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_888_3986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6345 11.9496L19.9227 12.4458L21.201 14.6577H21.2057L26.9139 24.5114L29.689 29.2968H38.163L42.407 21.9749L39.5482 17.0457L32.5524 4.96162L29.6843 0H21.1917L16.9617 7.32187L19.6298 11.9496",
    fill: "#A066CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_888_3986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4407 0H0V29H25.4407V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_888_3986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88201 12.302H2.87271L10.1335 24.873L10.1521 24.8638L12.7227 29.2968H21.1967L25.4407 21.9749L21.1967 14.653L16.9573 7.34042L16.9713 7.31724L12.718 0H4.24399L0 7.32187L2.88201 12.3067",
    fill: "#1836B2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.926 25.5037L56.241 3.83948H61.1357L65.4216 21.9842H64.1107L68.6289 3.83948H73.2913L77.8095 21.9842H76.4987L80.7845 3.83948H85.6793L79.9943 25.5037H74.7462L70.2001 8.05918H71.7155L67.1693 25.5037H61.9213H61.926Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9052 25.5037C95.3247 25.5037 93.8558 25.2301 92.4985 24.6876C91.1412 24.145 89.9605 23.3753 88.9564 22.3922C87.9477 21.4046 87.1621 20.2546 86.5997 18.9423C86.0326 17.63 85.7537 16.2018 85.7537 14.6623C85.7537 13.1228 86.0326 11.6946 86.5857 10.3823C87.1389 9.07005 87.9245 7.92007 88.9285 6.94629C89.9372 5.96788 91.1179 5.20741 92.4706 4.66487C93.8279 4.12234 95.3015 3.84875 96.9052 3.84875C98.5089 3.84875 99.9824 4.12234 101.34 4.66487C102.697 5.20741 103.878 5.97252 104.882 6.94629C105.891 7.92471 106.671 9.07005 107.225 10.3823C107.778 11.6993 108.057 13.1228 108.057 14.6623C108.057 16.2018 107.773 17.63 107.211 18.9423C106.648 20.2592 105.858 21.4092 104.854 22.3922C103.845 23.3799 102.665 24.145 101.312 24.6876C99.9545 25.2301 98.4903 25.5037 96.9052 25.5037ZM96.9052 21.5622C97.8674 21.5622 98.7552 21.3953 99.5733 21.0568C100.391 20.7183 101.112 20.2453 101.735 19.6332C102.358 19.0211 102.837 18.2931 103.176 17.4492C103.515 16.6052 103.683 15.6732 103.683 14.6623C103.683 13.6514 103.515 12.724 103.176 11.8894C102.837 11.0547 102.358 10.3267 101.735 9.70533C101.112 9.08396 100.391 8.61099 99.5733 8.28176C98.7552 7.95253 97.8627 7.79023 96.9052 7.79023C95.9476 7.79023 95.0551 7.95253 94.237 8.28176C93.4189 8.61099 92.6984 9.08396 92.0755 9.70533C91.4526 10.3267 90.9738 11.0547 90.6345 11.8894C90.2951 12.724 90.1278 13.6514 90.1278 14.6623C90.1278 15.6732 90.2951 16.6052 90.6345 17.4492C90.9738 18.2931 91.4526 19.0211 92.0755 19.6332C92.6984 20.2453 93.4189 20.7183 94.237 21.0568C95.0551 21.3953 95.9476 21.5622 96.9052 21.5622Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.116 25.5037V21.8683L118.999 7.76704H109.702V3.83948H124.712V7.47491L114.862 21.5761H125.005V25.4991H109.121L109.116 25.5037Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_888_3986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWozLogo);
export default __webpack_public_path__ + "static/media/WOZLogo.f023035da9a78b8f850bca12b1b50271.svg";
export { ForwardRef as ReactComponent };